export const CONTENT_CONTAINER_SPRING_PROPS = Object.freeze({
    default: {
        translation: 100
    },
    active: {
        translation: 0
    }
});

export const CONTENT_SPRING_PROPS = {
    default: {
        opacity: 0,
        translation: 25
    },
    active: {
        opacity: 1,
        translation: 0
    }
};

export const TITLE_SPRING_PROPS = {
    default: {
        translation: -25,
        opacity: 0
    },
    active: {
        translation: 0,
        opacity: 1
    }
};
